import { render, staticRenderFns } from "./ManageUserAccess.vue?vue&type=template&id=2ec71836"
import script from "./ManageUserAccess.vue?vue&type=script&lang=js"
export * from "./ManageUserAccess.vue?vue&type=script&lang=js"
import style0 from "./ManageUserAccess.vue?vue&type=style&index=0&id=2ec71836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports